export interface IAnyoPartner {
  id?: string;
  _id?:string;
  partnerId?: string;
  companyBranch: string;
  companyName: string;
  partnerType: string;
  companySector: string;
  websiteLink: string;
  address: string;
  city: string;
  state: string;
  year: string;
  totalStrength: number;
  ownership: string;
  status?: Status;
  isListed?: boolean;
  isProfitable?: boolean;
  spocDetails: ISpocDetails[];
  createdAt?: Date;
  createdBy?: string;
  lastModifiedAt?: Date;
  lastModifiedBy?: string;
  allowFamilyInvites?: boolean;
  maxFamilyInvitesAllowed?: number;
  archived?: boolean;
  companyLogoUrl?: string;
  dataCollection?: {
    phoneNumber: boolean;
    email: boolean;
    name: boolean;
    gender: boolean;
    dob: boolean;
  };
  companyMetaConfig?: CompanyMetaConfigField[];
  whitelistedDomains?: string[];
  partnerPortalDashboardId?: string;
  partnerPortalDashboardUrl?: string;
  clientCode?: string;
  ssoDomains?: Record<string, IPartnerSsoDomain>;
  isTesting: boolean;
  allowMarketingEmailNotifications?: boolean;
  restrictUserPostReplies?: boolean;
}

export enum CompanyMetaAppliesTo {
  CORPORATE = 'corporate',
  FAMILY = 'family',
}

export interface CompanyMetaConfigField {
  key: string;
  label: string;
  options: string[];
  required: boolean;
  appliesTo: CompanyMetaAppliesTo;
  order: number;
  enabled: boolean;
}

export interface IPartnerSsoDomain {
  domain: string;
  enabled: boolean;
  saml: {
    sp: {
      type: 'firebase' | 'anyobackend';
      providerId: string;
      signRequest?: boolean;
      gipInboundSamlConfigName?: string;
    };
    idp: {
      type: 'azure' | 'gsuite';
      entityId: string;
      ssoUrl: string;
      certRef?: string;
      x509Certificate?: string;
    };
  };
}

export enum Status {
  'Active' = 'active',
  'Inactive' = 'inactive',
}

export interface ISpocDetails {
  name: string;
  email: string;
  mobile: string;
  isOperations: boolean;
  id?: string;
  u_id?: string;
}
